/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TourPreviewPageQueryVariables = {
    tourID: string;
};
export type TourPreviewPageQueryResponse = {
    readonly tour: {
        readonly " $fragmentRefs": FragmentRefs<"TourPreview_tour">;
    } | null;
};
export type TourPreviewPageQuery = {
    readonly response: TourPreviewPageQueryResponse;
    readonly variables: TourPreviewPageQueryVariables;
};



/*
query TourPreviewPageQuery(
  $tourID: ID!
) {
  tour: node(id: $tourID) {
    __typename
    ...TourPreview_tour
    id
  }
}

fragment TourPlayerCanvas_tour on Tour {
  id
  title
  description
  videoURL
  thumbnailURL
  tourIntroLogoURL
  videoInfo {
    width
    height
    fullSize
    mediumSize
    smallSize
  }
  markers {
    id
    name
    description
    scrollPosition
    frameIndex
  }
  clips {
    id
    index
    frameCount
    duration
    highURI
    lowURI
  }
}

fragment TourPreviewMarkers_tour on Tour {
  markers {
    id
    name
    isFastTravel
    frameIndex
  }
}

fragment TourPreview_tour on Tour {
  ...TourPreviewMarkers_tour
  ...TourPlayerCanvas_tour
  id
  thumbnailURL
  title
  viewingSessionRequest {
    rtcToken
    signalingToken
    appId
    viewingSessionUserId
    expireTime
  }
  inspections {
    id
    title
    inspectionStatus
    inspectionDate
    propertyAddress
    inspectorName
    defects {
      id
      title
      description
      severity
      defectStatus
      roomType
      defectCategory
      sourceClipIndex
      sourceFramePosition
      aiDetected
      aiConfidence
      evidenceImageURI
      audioStartSeconds
      audioEndSeconds
    }
    audioSubmissions {
      id
      videoURI
      originalFilename
      submissionStatus
      rawTranscript
      durationSeconds
      errorMessage
      createdAt
    }
  }
  clips {
    id
    index
    frameCount
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "tourID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourPreviewPageQuery",
    "selections": [
      {
        "alias": "tour",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TourPreview_tour"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourPreviewPageQuery",
    "selections": [
      {
        "alias": "tour",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Marker",
                "kind": "LinkedField",
                "name": "markers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFastTravel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frameIndex",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scrollPosition",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tourIntroLogoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TourVideoInfo",
                "kind": "LinkedField",
                "name": "videoInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediumSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallSize",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Clip",
                "kind": "LinkedField",
                "name": "clips",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "index",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frameCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highURI",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lowURI",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ViewingSessionRequest",
                "kind": "LinkedField",
                "name": "viewingSessionRequest",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rtcToken",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signalingToken",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewingSessionUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expireTime",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertyInspection",
                "kind": "LinkedField",
                "name": "inspections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inspectionStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inspectionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "propertyAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inspectorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefectItem",
                    "kind": "LinkedField",
                    "name": "defects",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "severity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defectStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roomType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defectCategory",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceClipIndex",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceFramePosition",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiDetected",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiConfidence",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "evidenceImageURI",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "audioStartSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "audioEndSeconds",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionAudioSubmission",
                    "kind": "LinkedField",
                    "name": "audioSubmissions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoURI",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalFilename",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submissionStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rawTranscript",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "durationSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorMessage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Tour",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea0d002b6d5cbeaeef22527886bbba66",
    "id": null,
    "metadata": {},
    "name": "TourPreviewPageQuery",
    "operationKind": "query",
    "text": "query TourPreviewPageQuery(\n  $tourID: ID!\n) {\n  tour: node(id: $tourID) {\n    __typename\n    ...TourPreview_tour\n    id\n  }\n}\n\nfragment TourPlayerCanvas_tour on Tour {\n  id\n  title\n  description\n  videoURL\n  thumbnailURL\n  tourIntroLogoURL\n  videoInfo {\n    width\n    height\n    fullSize\n    mediumSize\n    smallSize\n  }\n  markers {\n    id\n    name\n    description\n    scrollPosition\n    frameIndex\n  }\n  clips {\n    id\n    index\n    frameCount\n    duration\n    highURI\n    lowURI\n  }\n}\n\nfragment TourPreviewMarkers_tour on Tour {\n  markers {\n    id\n    name\n    isFastTravel\n    frameIndex\n  }\n}\n\nfragment TourPreview_tour on Tour {\n  ...TourPreviewMarkers_tour\n  ...TourPlayerCanvas_tour\n  id\n  thumbnailURL\n  title\n  viewingSessionRequest {\n    rtcToken\n    signalingToken\n    appId\n    viewingSessionUserId\n    expireTime\n  }\n  inspections {\n    id\n    title\n    inspectionStatus\n    inspectionDate\n    propertyAddress\n    inspectorName\n    defects {\n      id\n      title\n      description\n      severity\n      defectStatus\n      roomType\n      defectCategory\n      sourceClipIndex\n      sourceFramePosition\n      aiDetected\n      aiConfidence\n      evidenceImageURI\n      audioStartSeconds\n      audioEndSeconds\n    }\n    audioSubmissions {\n      id\n      videoURI\n      originalFilename\n      submissionStatus\n      rawTranscript\n      durationSeconds\n      errorMessage\n      createdAt\n    }\n  }\n  clips {\n    id\n    index\n    frameCount\n  }\n}\n"
  }
};
})();
(node as any).hash = '2e2d973652ca1d9ff9e9120181062198';
export default node;
